import { MenuItem } from '@material-ui/core';
import React from 'react';
import { Divider } from '../common/Divider';
import { HorizontalSelect, SelectProps } from '../common/HorizontalSelect';
import { SortField, SortOrder } from '../../hooks/useSortSettings';

export type UploadSortValue = `${SortField}-${SortOrder}`;

export const convertUploadSort = (
  value: UploadSortValue,
): { sortField: SortField; sortOrder: SortOrder } => {
  const [sortField, sortOrder] = value.split('-') as [SortField, SortOrder];
  return { sortField, sortOrder };
};

export const UploadSortSelect: React.FC<
  Pick<SelectProps<UploadSortValue>, 'value' | 'onChange'>
> = (props) => (
  <HorizontalSelect<UploadSortValue> id='table-sort' label='Sort by' {...props}>
    <MenuItem value='modifiedAt-desc'>Latest change</MenuItem>
    <MenuItem value='modifiedAt-asc'>Oldest change</MenuItem>
    <Divider />
    <MenuItem value='name-asc'>Name Ascending</MenuItem>
    <MenuItem value='name-desc'>Name Descending</MenuItem>
    <Divider />
    <MenuItem value='type-asc'>Type Ascending</MenuItem>
    <MenuItem value='type-desc'>Type Descending</MenuItem>
  </HorizontalSelect>
);
